const columns = (dynamicColumns) => [
  {
    key: 'branch',
    label: '',
  },
  ...dynamicColumns,
];

export default columns;
